import React from 'react'
import type { ReadonlyDeep } from 'type-fest'

import type { AnyStepContentElement, ConditionValues } from '@flows/core/types/stepContentTypes'
import type { ComponentMap } from '@flows/renderer/types'

import { evaluateDisabledCondition } from './conditions'

export const mapElement = (stepComponents: ReadonlyDeep<ComponentMap>) => (element: any) => {
  const Component = stepComponents[element.type] as React.ElementType | undefined

  if (Component === undefined || Component === null) {
    throw new Error(`Assertion: invalid type "${element.type}"`)
  }

  const key = `stepElement-${element.type}-${element.name ?? JSON.stringify(element)}`

  return <Component key={key} {...element} />
}

export const disableElement = <TStepContentElement extends ReadonlyDeep<AnyStepContentElement>>(
  element: TStepContentElement,
  conditions: ConditionValues
) => {
  const condition =
    element && 'disabledConditionConfig' in element && element.disabledConditionConfig?.condition

  const value =
    (element &&
      'disabledConditionConfig' in element &&
      element.disabledConditionConfig?.fallbackValue) ||
    undefined

  if (condition && evaluateDisabledCondition(conditions, condition)) {
    return { ...element, disabled: true, value }
  }
  return element
}
